/* eslint-disable func-call-spacing */

// See https://webpack.js.org/concepts/module-federation/#troubleshooting
import ('./bootstrap')
